module.exports = __webpack_public_path__ + "static/media/diagnostics.17a675be.jpg";